import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { CountryListDTO } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

export interface CountryStatesRequest {
  countryCode: string | undefined;
}

const useGetCountryStatesList = ({ countryCode }: CountryStatesRequest) => {
  const brandName = useOnlineBookingStore(state => state.brandName);

  const url = useApiUrl(
    OBRoutes.CountryStates,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##countryCode', countryCode || '');

  // if brandName -> this service is not needed
  const enabled = !!url && !!countryCode && !brandName;

  const query = useOBQuery<CountryListDTO>(url, { enabled });

  return {
    ...query,
    isLoading: enabled ? query.isLoading : false,
  };
};

export default useGetCountryStatesList;
